module.exports = __webpack_public_path__ + "img/Bartek.7e7a79b0.png";